<script>
    import { operationStore, query } from '@urql/svelte';
    import LoadingAnim from "./loadingAnim.svelte"
    const getAboutContent = operationStore(`
    {
      about: entry(section: "pages", slug: "about") {
        id
        title
        ... on about_Entry {
            aboutText
            aboutImage {
                url
                title
            }
        }
      }
    }`);
    query(getAboutContent);
</script>
<main class="content about">
    <h1>About</h1>
    {#if $getAboutContent.fetching}
        <LoadingAnim/>
    {:else if $getAboutContent.error}
        <p>Oh no... {$getAboutContent.error.message}</p>
    {:else}
        <div class="about-content jetnoise-grid">
            <div class="about-text">
                {@html $getAboutContent.data.about.aboutText}
                <a href="mailto:rolf@jetnoise.ch" class="link-btn black"><img src="/assets/envelope-regular.svg" alt="e-mail icon" /> rolf@jetnoise.ch</a>
            </div>
            <div class="about-image">
                <img src="{$getAboutContent.data.about.aboutImage[0].url}" alt="{$getAboutContent.data.about.aboutImage[0].title}">
            </div>
        </div>
    {/if}
</main>
<style lang="scss">
    .about-text {
      background-color: var(--background);
      padding: var(--default-padding);
      box-shadow: var(--box-shadow);
      .link-btn {
        display: flex;
        width: fit-content;
        margin-top: var(--default-padding);
      }
      //grid-column: 1 / span 2;
    }
    .about-image {
      width: 100%;
      img {
        box-shadow: var(--box-shadow);
        width: 100%;
      }
    }
    @media screen and (max-width: 750px) {
      .jetnoise-grid {
        grid-template-columns: repeat(1, 1fr);
      }
    }
</style>